<footer class="app-footer">
  <div class="app-footer__content">
    <img src="/icons/logo-footer.svg" alt="Claro América Móvil" class="app-footer__logo-img" />
    <div class="app-footer__meta">
      <span class="app-footer__copyright">©Copyright {{ currentYear }}</span>
      <span class="app-footer__version">{{ appVersion }}</span>
    </div>
  </div>
</footer>
